import { render, staticRenderFns } from "./ColorPickr.vue?vue&type=template&id=501c4abb&"
import script from "./ColorPickr.vue?vue&type=script&lang=js&"
export * from "./ColorPickr.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickr.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports